// CANONICAL COPY (GH #7115). src/constants/obligations/obl-source-code-access.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-source-code-access',
  title: 'Verify access to source code is restricted',
  description:
    'Confirm that read and write access to source code, development tools and software libraries is appropriately restricted to protect against the introduction of unauthorised functionality, to avoid unintentional changes and to maintain the confidentiality of valuable intellectual property. Controls shall include branch-protection rules, enforced code review, restricted merge permissions, auditable commit history, separation between source-code repositories and production systems, and periodic access-right review for repositories and build systems. Review the source-code access standard and repository access records.',
  category: 'access',
  scfIds: ['SCF-IAM-007'],
  cadence: { frequency: '6m', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Source code access standard is published' },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
